module.exports = __webpack_public_path__ + "img/tondo_logo_white.c79c7479.svg";